<template>
  <div class="container-fluid">
    <header class="home-header" v-bind:style="backgroundImage">
      <div class="row">
        <div class="col-md-6 mobile-links-container">
          <mobile-store-links class="background-mobile-links"></mobile-store-links>
        </div>
        <div class="col-12 col-md-6">
          <div class="row">
            <div class="col">
              <h1 class="title">Get The Yarlow HomFAX Report</h1>
            </div>
          </div>
          <div class="row right-padding">
            <div class="col-md-6">
              <div class="homfax-report-bubble">
                <img src="/static/YellowCheck.svg" class="yellow-check-mark" alt="Yellow Check Mark">
                <h3 class="homfax-report-bubble-title">Track Your Home Maintenance</h3>
                <p class="homfax-report-bubble-text">Easily add pictures of receipts, warranty information, contractor work, and DIY projects to your Yarlow HomFAX profile.</p>
                <a class="learn-more" v-on:click="scrollTo('appliances')">Learn More ></a>
              </div>
            </div>
            <div class="col-md-6">
              <div class="homfax-report-bubble">
                <img src="/static/YellowCheck.svg" class="yellow-check-mark" alt="Yellow Check Mark">
                <h3 class="homfax-report-bubble-title">Ready To Buy?</h3>
                <p class="homfax-report-bubble-text">Want to know what you are buying before investing hundreds of thousands of dollars? Get a Yarlow HomFAX Report.</p>
                <router-link to="/homfaxreport">Learn More ></router-link>
              </div>
            </div>
          </div>
          <div class="row right-padding">
            <div class="col-md-6">
              <div class="homfax-report-bubble">
                <img src="/static/YellowCheck.svg" class="yellow-check-mark" alt="Yellow Check Mark">
                <h3 class="homfax-report-bubble-title">Add Your Projects</h3>
                <p class="homfax-report-bubble-text">Doing a DIY project or hiring a contractor? Keep track of your project in Yarlow HomFAX to make sure you know how to maintain your new feature.</p>
                <a class="learn-more" v-on:click="scrollTo('diy')">Learn More ></a>
              </div>
            </div>
            <div class="col-md-6">
              <div class="homfax-report-bubble">
                <img src="/static/YellowCheck.svg" class="yellow-check-mark" alt="Yellow Check Mark">
                <h3 class="homfax-report-bubble-title">Ready To Sell?</h3>
                <p class="homfax-report-bubble-text">Want to be rewarded for all your hard work? Get paid from potential home buyers for your Yarlow HomFAX Report.</p>
                <router-link to="/homfaxreport">Learn More ></router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="row">
      <div class="col">
        <h2 class="second-section-title">Let's Get Started!</h2>
      </div>
    </div>
    <div class="row bottom-margin side-margins">
      <div class="col-md-4">
        <div class="opaque-picture-container">
          <img src="/static/AppliancesImage.jpg" class="opaque-picture" alt="Appliances">
          <h3 class="opaque-picture-text opaque-picture-side-text">Appliances</h3>
        </div>
      </div>
      <div class="col-md-4">
        <div class="opaque-picture-container">
          <img src="/static/ToolsImage.jpg" class="opaque-picture" alt="Tools">
          <h3 class="opaque-picture-text opaque-picture-center-text">DIY</h3>
        </div>
      </div>
      <div class="col-md-4">
        <div class="opaque-picture-container">
          <img src="/static/LadderImage.jpg" class="opaque-picture" alt="Ladder">
          <h3 class="opaque-picture-text opaque-picture-side-text">Contractors</h3>
        </div>
      </div>
    </div>
    <div class="row gray-banner bottom-margin">
      <div class="col-md-6 third-section-title-container">
        <h3 class="third-section-title">How It Works</h3>
      </div>
      <div class="col-12 col-md-6">
        <ol class="instructions-list">
          <li class="instruction-item">Download the Yarlow HomFAX app or start a <router-link to="/propertysearch">home search</router-link> now.<br>
          <mobile-store-links></mobile-store-links></li>
          <li class="instruction-item">Sign up!<br><br>Use an email to create an account. If you are working with a realtor, enter the realtor's code to get a customized experience.</li>
          <li class="instruction-item">Claim your house and start managing your home.<br><br>Search for your house and click "Claim." Now you can keep track of everything from the type of lightbulbs used in each room to warranty information on your appliances.</li>
        </ol>
      </div>
    </div>
    <div ref="appliances" class="row">
      <div class="col-md-6 placeholder">
        <img src="/static/AppliancesMobileMockup.png" class="cell-screen">
      </div>
      <div class="col-md-6">
        <h3 class="block-title">Appliances</h3>
        <p class="block-text">Need to find a replacement part for your fridge? Whether you are looking for a replacement drawer or a new water filter, having the product information at your fingertips makes it easy! The more facts you put into Yarlow HomFAX, the better you will be able to maintain your home.</p>
      </div>
    </div>
    <div ref="diy" class="row">
      <div class="col-md-6 order-md-2 placeholder">
        <img src="/static/HomFAXSummaryMobileMockup.png" class="cell-screen">
      </div>
      <div class="col-md-6 order-md-1">
        <h3 class="block-title">Do It Yourself</h3>
        <p class="block-text">Keeping track of DIY projects can help automate your paperwork. Easily look up materials used, project cost analytics, product warranty information and more. Yarlow HomFAX can provide the needed IRS documentation to reduce your tax liability when selling your house.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 placeholder">
        <img src="/static/HomFAXRecordsMobileMockup.png" class="cell-screen">
      </div>
      <div class="col-md-6">
        <h3 class="block-title">Contractors</h3>
        <p class="block-text">Did you hire a contractor? Take a photo of the bill and work performed. Now you can throw away all that paper and easily find the contractor information. Need to know the last time your ducts were cleaned? Don’t scrounge for that piece of paper. Just a click tells you everything you need to know!</p>
      </div>
    </div>
    <div class="row gray-banner bottom-margin">
      <div class="col">
        <div class="row">
          <div class="col">
            <h3 class="fourth-section-title">Why Yarlow HomFAX?</h3>
          </div>
        </div>
        <div class="row side-margins">
          <div class="col-md-3">
            <h4 class="gray-banner-col-title">Improve Buyer Education</h4>
            <p class="gray-banner-col-text">Whether you are a first-time home buyer or seasonal homeowner, it is always a guessing game to know how much it will cost to keep your new home running smoothly. Seeing what services the previous owner contracted for and performed themselves allows you to see a relative annual maintenance cost. Factoring the maintenance cost into your budget before purchasing your home can help reduce anxiety and make your experience more comfortable.</p>
          </div>
          <div class="col-md-3">
            <h4 class="gray-banner-col-title">Learn About Homeownership</h4>
            <p class="gray-banner-col-text">Unsure what maintenance you need to perform on your house? Yarlow HomFAX can send you notifications for when you need to change the air filter or seed the lawn. Don't have a lawn? Yarlow HomFAX tailors tips and notifications to the type of the home you have and the state you live. Help maintain your property value and learn how small investments can really pay off.</p>
          </div>
          <div class="col-md-3">
            <h4 class="gray-banner-col-title">Information At Your Fingertips</h4>
            <p class="gray-banner-col-text">Need a new water filter for your fridge? Have burnt out lightbulbs? With Yarlow HomFAX all of this information can be at your fingertips. No need to search around the house to find the fridge model number or lightbulb wattage and size. Open the Yarlow HomFAX app and instantly be able to see what you need. Painting a room? Take a picture of the paint can information and receipt so you can easily order more paint if needed.</p>
          </div>
          <div class="col-md-3">
            <h4 class="gray-banner-col-title">Build a History</h4>
            <p class="gray-banner-col-text">Ready to throw out that old filing cabinet full of warranty, contractor and receipt information? Add it all to the Yarlow HomFAX app for free! When you sell your home, the buyer has the option to purchase your Yarlow HomFAX report or Data Transfer. This "Yarlow HomFAX Report" allows the buyer to see your home information. A "Data Transfer" moves the home information to the buyer's account so they can continue to add Yarlow HomFAX.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MobileStoreLinks from '../general/buttons/MobileStoreLinks.vue'

export default {
  metaInfo: {
    title: 'Home',
    meta: [
      { vmid: 'description', content: 'Learn about how to maintain, buy and sell houses.' }
    ]
  },
  components: {
    MobileStoreLinks
  },
  computed: {
    backgroundImage () {
      return 'background-image: url("/static/HomePageBackground.svg")'
    }
  },
  methods: {
    scrollTo (location) {
      let element = this.$refs[location]
      let top = element.offsetTop
      window.scrollTo(0, top)
    }
  }
}
</script>

<style scoped>
.block-text {
  color: #707070;
  font-size: 1.2rem;
  margin-bottom: 20rem;
  margin-top: 5rem;
  padding-left: 3rem;
  padding-right: 3rem;
}

.block-title {
  font-size: 3rem;
  margin-top: 20rem;
  text-align: center;
}

.bottom-margin {
  margin-bottom: 6rem;
}

.cell-screen {
  margin-top: 25%;
  max-width: 40% !important;
}

.container-fluid {
  height: 100%;
  padding: 0;
}

.fourth-section-title {
  font-size: 2.5rem;
  margin-bottom: 3rem;
  margin-top: 6rem;
  text-align: center;
}

.gray-banner {
  padding-bottom: 3rem;
  padding-top: 3rem;
}

.gray-banner-col-title {
  font-size: 1.3rem;
  text-align: center;
}

.gray-banner-col-text {
  color: #707070 !important;
}

.home-header {
  background-size: cover;
  background-position: center center;
  padding-bottom: 3rem;
  padding-top: 3rem;
  margin-bottom: 5rem;
}

.homfax-report-bubble {
  background: white;
  border-radius: 25px;
  border-style: solid;
  border-width: thin;
  margin-bottom: 2rem;
  padding: 25px;
}

.homfax-report-bubble-text {
  line-height: 1.2rem;
  margin-bottom: 10px;
  margin-top: 10px;
}

.homfax-report-bubble-title {
  display: inline;
  font-size: 1rem;
  vertical-align: middle;
}

.instruction-item {
  color: #707070;
  font-size: 1.2rem;
  margin-bottom: 25px;
}

.instructions-list {
  list-style-position: outside;
}

.learn-more {
  color: #007bff !important;
}

.learn-more:hover {
  color: #0056b3 !important;
  cursor: pointer;
}

.mobile-links-container {
  position: relative;
}

.background-mobile-links {
  bottom: 0;
  left: 17%;
  position: absolute;
}

.opaque-picture {
  border-radius: 25px;
  border-style: solid;
  border-width: thin;
  object-fit: cover;
  opacity: 0.5;
  width: 100%;
}

.opaque-picture-container {
  position: relative;
}

.opaque-picture-text {
  font-size: 3rem;
  font-weight: bold;
  position: absolute;
  text-align: center;
}

@media (max-width: 570px) {
  .opaque-picture-text {
    top: 40%;
  }

  .opaque-picture-side-text {
    left: 10%
  }

  .opaque-picture-center-text{
    left: 40%;
  }
}

@media (min-width: 570px) {
  .opaque-picture-text {
    top: 47%;
  }

  .opaque-picture-side-text {
    left: 22%
  }

  .opaque-picture-center-text{
    left: 40%;
  }
}

.placeholder {
  background: #363E4A;
  padding: 0;
  text-align: center;
}

.right-padding {
  padding-right: 1rem;
}

.second-section-title {
  font-size: 2.5rem;
  margin-bottom: 8rem;
  margin-top: 3rem;
  text-align: center;
}

.side-margins {
  margin-left: 2.5rem;
  margin-right: 2.5rem;
}

.third-section-title {
  font-size: 2.5rem;
  margin: auto;
}

.third-section-title-container {
  display: flex;
}

.title {
  font-size: 1.5rem;
  margin-bottom: 2rem;
  margin-top: 3rem;
  text-align: center;
}

.yellow-check-mark {
  display: inline;
  width: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/HomePage.vue